import { Component } from '@verndale/core';
import {
  TIERSMAP,
  ACCESS_CLASS_MAP,
  AMENITIES_ARRAY,
  FOOD_BEVERAGE_ARRAY,
  FACILITIES_ARRAY,
  ENTERTAINMENT_COMMS_ARRAY
} from '../constants';
import { getParameterByName } from '../helpers';
import FindLounges from './FindLounges';
import _template from 'lodash/template';
import loungeTemplate from '../templates/lounge.html';
import Lounge from '../modules/Lounge';
import fastTrackTemplate from '../templates/fast-track.html';
import {
  findLounges,
  getAirports,
  searchAirportFastTrack
} from '../service/oneworld';

class LoungesList extends Component {
  constructor(el) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      $searchLounges: $('.search-lounges'),
      $searchLoungesForm: $('.search-lounges__form'),
      $placeholder: this.$el.find('.lounges-list__placeholder'),
      $noResultsMsg: this.$el.find('.lounges-list__no-results'),
      $spinner: this.$el.find('.spinner'),
      $fastTrackPlaceholder: $('.fast-track__placeholder'),
      $fastTrack: $('.fast-track'),
      $fastTrackTooltip: $('.fast-track__availableTerminals__title span')
    };

    this.loungesUrl = this.dom.$searchLoungesForm.attr('action');

    this.findLounges = new FindLounges(this.dom.$searchLounges, {
      onFind: ::this.displayLounges
    });

    const location = getParameterByName('location');

    if (location && !this.dom.$searchLoungesForm.data('redirect-when-location-params')) {
      this.findLounges.setLocation(location);
      this.displayLounges({ location });
    }
  }

  overrideTitle(label) {
    const title = document.querySelector('title');
    const metaTitle = document.querySelector('meta[property="og:title"]');
    const body = document.querySelector('body');
    if (body && body.dataset.pageTitleOverride && body.dataset.pageTitleOverride !== '' && title) {
      title.innerHTML = body.dataset.pageTitleOverride.replace('{airport}', label);
      if (metaTitle) {
        metaTitle.setAttribute('content', body.dataset.pageTitleOverride.replace('{airport}', label));
      }
    }
  }

  renderFastTrack(fastTrackData) {
    const html = _template(fastTrackTemplate)({ fastTrackData });
    $(this.dom.$fastTrack).addClass('fast-track--active');
    this.dom.$fastTrackPlaceholder.html(html);
    $(window).scroll(() => $('.fast-track___tooltipInfo').slideUp());
    $(window).on('touchstart', () => $('.fast-track___tooltipInfo').slideUp());
    $('.fast-track__tooltipTrigger').click(e => {
      e.stopPropagation();
      $('.fast-track___tooltipInfo').slideDown('medium');
    });
    $('.fast-track__tooltipTrigger').hover(
      () => $('.fast-track___tooltipInfo').stop(true, true).slideDown('medium'),
      () => $('.fast-track___tooltipInfo').stop(true, true).slideUp('medium')
    );
  }

  async displayLounges(data) {
    const qsString = $.param(data);
    const airportCode = data.location.toUpperCase();
    let url = location.pathname;

    if (qsString) {
      url = `${url}?${qsString}`;
    }

    window.history.pushState({}, null, url);

    if (typeof airportCode !== 'undefined' && airportCode !== '') {
      //Reset state
      this.dom.$noResultsMsg.hide();
      this.dom.$placeholder.html('');
      this.dom.$fastTrackPlaceholder.html('');
      //show busy state
      this.dom.$spinner.addClass('is-active').fadeIn();
      //get data
      const airports = await getAirports({ url: this.airportsUrl });
      const airport = airports.find(item => item.Code === airportCode);
      // get fasttrack data
      const fastTrackData = await searchAirportFastTrack(airportCode);
      const data = await findLounges({
        airport: airportCode,
        url: this.loungesUrl
      }).catch(e => {
        console.log('error: ');
        console.log(e);
      });

      //remove busy state
      this.dom.$spinner.hide().removeClass('is-active');

      //process data
      if (typeof data !== 'undefined' && data.length > 0) {
        const processedLoungeData = this.processLoungedata(data);
        //render lounges
        this.renderLounges(processedLoungeData);
        this.renderFastTrack({
          airportName: `${airport.Name}`,
          loungesCount: `${data.length} Lounge${data.length > 1 ? 's' : ''}`,
          terminalMapImage:
            (fastTrackData && fastTrackData.terminalMapImage) || false,
          hasFastTrack: (fastTrackData && fastTrackData.hasFastTrack) || false,
          fastTrackTerminals:
            (fastTrackData && fastTrackData.fastTrackTerminals) || false,
          viewTerminalLabel: fastTrackData.terminalLabel,
          viewTerminalUrl: fastTrackData.terminalUrl,
          viewTerminalTarget: fastTrackData.terminalTarget
        });
        this.overrideTitle(airport.Name);
      } else {
        //display no results
        this.dom.$noResultsMsg.show();
      }
    }
  }

  processLoungedata(data) {
    this.processedLoungeData = data.map(originalLounge => {
      const processedLounge = {};

      //Title
      processedLounge.Title = originalLounge.Name;

      //Subtitle
      processedLounge.Subtitle = `(${originalLounge.AirportCode}) ${originalLounge.AirportName} ${originalLounge.Terminal}`;

      //Tiers and Classes
      processedLounge.Tiers = TIERSMAP[originalLounge.AccessTier];
      processedLounge.AccessClass =
        ACCESS_CLASS_MAP[originalLounge.AccessClass];
      processedLounge.AccessConditions = originalLounge.AccessConditions;
      processedLounge.AccessNotes = originalLounge.AccessNotes;

      //Airlines
      processedLounge.Airlines = originalLounge.Airlines.map(airline => {
        return airline.Name;
      });

      //Gallery Images
      processedLounge.Images = originalLounge.Images.map(imageObj => {
        const imageInfo = JSON.parse(imageObj.Pointer);
        return imageInfo.Original;
      });

      //Amenities
      processedLounge.Amenities = AMENITIES_ARRAY.reduce((acc, amenity) => {
        if (originalLounge[amenity]) {
          acc.push(`Amenities-${amenity}`);
        }
        return acc;
      }, []);

      //Open Hours
      processedLounge.OpenHours = originalLounge.OpenHours;
      processedLounge.DisplayOpenHours = false;
      processedLounge.OpenHoursNotes = originalLounge.EntertainmentNotes;

      if (processedLounge.OpenHours && processedLounge.OpenHours.length > 0) {
        const openHours = processedLounge.OpenHours.filter(
          openHour =>
            openHour.OpeningHour || openHour.OpenAllDay || openHour.CloseAllDay
        );
        processedLounge.DisplayOpenHours = openHours.length > 0;
        processedLounge.Days = [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday'
        ];
      }

      if (originalLounge.ScheduleNotes === '') {
        processedLounge.ScheduleNotes = null;
      } else {
        processedLounge.ScheduleNotes = originalLounge.ScheduleNotes;
      }
      //Location
      processedLounge.Location = [];
      processedLounge.Location.push(originalLounge.Terminal);
      processedLounge.Location.push(originalLounge.Concourse);
      processedLounge.Location.push(originalLounge.Near);
      processedLounge.Location.push(
        originalLounge.LocationSecurity.replace(/([a-z])([A-Z])/g, '$1 $2')
      );
      processedLounge.Location = processedLounge.Location.filter(
        element => element !== ''
      );
      processedLounge.Location = processedLounge.Location.join(', ');

      //Complementary Food
      processedLounge.FoodOptions = FOOD_BEVERAGE_ARRAY.reduce(
        (acc, foodOption) => {
          if (originalLounge[foodOption]) acc.push(`FoodOptions-${foodOption}`);
          return acc;
        },
        []
      );

      //Facilities
      processedLounge.Facilites = FACILITIES_ARRAY.reduce((acc, facility) => {
        if (originalLounge[facility]) acc.push(`Facilities-${facility}`);
        return acc;
      }, []);

      //Entertainment and Communications
      processedLounge.Entertainment = ENTERTAINMENT_COMMS_ARRAY.reduce(
        (acc, commOption) => {
          if (originalLounge[commOption])
            acc.push(`Entertainment-${commOption}`);
          return acc;
        },
        []
      );

      //Free Wifi is not boolean
      if (originalLounge.WiFi === 'Free') {
        processedLounge.Entertainment.push('Entertainment-FreeWifi');
      }
      return processedLounge;
    });
    return this.processedLoungeData;
  }

  renderLounges(data) {
    let loungesHTML = '';
    $(data).each((index, loungeData) => {
      loungeData.Airlines.sort();
      loungesHTML += _template(loungeTemplate)({
        loungeData
      });
    });
    this.dom.$placeholder.html(loungesHTML);
    //Show corresponding Amenities, etc sections
    this.initLounges();
  }

  initLounges() {
    const $lounges = this.$el.find('.lounge', this.dom.$placeholder);
    this.Lounges = [];
    $lounges.each((index, lounge) => {
      const newLounge = new Lounge($(lounge));
      this.Lounges.push(newLounge);
      this.displayInfo(newLounge, this.processedLoungeData[index]);
    });
  }

  displayInfo(loungeObj, relatedDataObj) {
    //Amenities
    if (relatedDataObj.Amenities.length > 0) {
      loungeObj.renderAvailableInfo(
        loungeObj.dom.$loungeAmenitiesInfo,
        relatedDataObj.Amenities
      );
    }
    //Entertainment
    if (relatedDataObj.Entertainment.length > 0) {
      loungeObj.renderAvailableInfo(
        loungeObj.dom.$loungeEntertainmentInfo,
        relatedDataObj.Entertainment
      );
    }
    //Facilities
    if (relatedDataObj.Facilites.length > 0) {
      loungeObj.renderAvailableInfo(
        loungeObj.dom.$loungeFacilitiesInfo,
        relatedDataObj.Facilites
      );
    }
    //Food
    if (relatedDataObj.FoodOptions.length > 0) {
      loungeObj.renderAvailableInfo(
        loungeObj.dom.$loungeFoodInfo,
        relatedDataObj.FoodOptions
      );
    }
  }
}

export default LoungesList;
